import {tryGetUserIdFromToken} from '@chekin/api';
import {LANGUAGE_CODES} from '@chekin/core';

export const GURUWALK_ORIGIN = 'https://www.guruwalk.com';
export const GURUWALK_AFFILIATE = import.meta.env.VITE_GURUWALK_AFFILIATE;
export const MOZIO_ORIGIN = 'https://chekin.mozio.com';

export const SUPPORTED_GURUWALK_LANGUAGES = [
  LANGUAGE_CODES.en,
  LANGUAGE_CODES.es,
  LANGUAGE_CODES.de,
  LANGUAGE_CODES.it,
];

export const getGuruWalkLanguage = (lang: string) => {
  const appLanguage = lang.slice(0, 2);
  if (SUPPORTED_GURUWALK_LANGUAGES.includes(appLanguage as LANGUAGE_CODES)) {
    return appLanguage;
  }
  return LANGUAGE_CODES.en;
};

export const buildGuruWalkOfferUrl = ({
  tourPath,
  reservationId,
}: {
  tourPath: string;
  reservationId?: string;
}) => {
  const affiliate = GURUWALK_AFFILIATE || '';
  try {
    const url = new URL(tourPath, GURUWALK_ORIGIN);
    url.searchParams.set('ref', affiliate);
    if (reservationId) url.searchParams.set('referrer_campaign', reservationId);
    url.searchParams.set('utm_source', 'affiliates');
    url.searchParams.set('utm_medium', 'affiliates_widget');
    url.searchParams.set('utm_campaign', affiliate);
    return url.toString();
  } catch (_error) {
    return GURUWALK_ORIGIN;
  }
};

export const createMozioHref = () => {
  const userId = tryGetUserIdFromToken();
  if (!userId) return MOZIO_ORIGIN;
  return `${MOZIO_ORIGIN}/?partner_tracking_id=${userId}`;
};
